'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _lodash = require('lodash');

var _Select = require('react-select/lib/Select');var _Select2 = _interopRequireDefault(_Select);

var _SearchEmployees = require('./SearchEmployees.scss');var styles = _interopRequireWildcard(_SearchEmployees);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Styles
var SearchEmployees = function (_Component) {_inherits(SearchEmployees, _Component);
  function SearchEmployees(props) {_classCallCheck(this, SearchEmployees);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.









    handleSelectChange = function (selected) {
      _this.setState({ searchType: selected.value }, function () {
        _this.debouncedSearch();
      });
    };_this.

    handleInputChange = function (event) {
      _this.setState({ searchQuery: event.target.value }, function () {
        _this.debouncedSearch();
      });
    };_this.

    handleSearch = function () {var _this$state =
      _this.state,searchType = _this$state.searchType,searchQuery = _this$state.searchQuery;
      var params = {
        search_field: searchType,
        search_value: searchQuery };


      if (searchQuery) {
        return _this.props.onHandleSearch({ params: params, token: _this.props.userToken });
      }

      return _this.props.onHandleSearch({ token: _this.props.userToken });
    };var firstOptionValue = props.searchOptions && props.searchOptions[0] && props.searchOptions[0].value;_this.state = { searchType: firstOptionValue || '', searchQuery: '' };_this.debouncedSearch = (0, _lodash.debounce)(_this.handleSearch, 1000);return _this;}SearchEmployees.prototype.

  render = function render() {var _props =
    this.props,translate = _props.translate,searchOptions = _props.searchOptions;var _state =
    this.state,searchType = _state.searchType,searchQuery = _state.searchQuery;
    var options = searchOptions.map(function (option) {return Object.assign({},
      option, {
        label: translate('myStaff', option.label).toString() });});

    var selectedOption = options.find(function (option) {return option.value === searchType;}) || null;

    return (
      _react2.default.createElement('div', { className: styles.flexPosition },
        _react2.default.createElement('p', { className: styles.title }, this.props.title),
        _react2.default.createElement('div', { className: styles.searchWrapper },
          _react2.default.createElement(_Select2.default, {
            className: styles.customSelect,
            options: options,
            value: selectedOption,
            onChange: this.handleSelectChange,
            searchable: false,
            clearable: false,
            classNamePrefix: 'rs' }),


          _react2.default.createElement('div', { className: styles.inputWrapper },
            _react2.default.createElement('input', {
              type: 'text',
              value: searchQuery,
              onChange: this.handleInputChange,
              placeholder: translate('myStaff', 'search'),
              className: styles.input }),

            _react2.default.createElement('span', { className: 'icon icon-search' }))),


        _react2.default.createElement('p', { className: styles.subTitle }, this.props.description)));


  };return SearchEmployees;}(_react.Component);


SearchEmployees.propTypes = {
  title: _propTypes2.default.func.isRequired,
  description: _propTypes2.default.func.isRequired,
  translate: _propTypes2.default.func.isRequired,
  searchOptions: _propTypes2.default.array.isRequired,
  userToken: _propTypes2.default.string,
  onHandleSearch: _propTypes2.default.func };exports.default =


SearchEmployees;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/SearchEmployees/SearchEmployees.js
// module id = 2967
// module chunks = 0